<template>
  <embed-viewer :url="url" :title="title" v-if="url" @close="onClose()"></embed-viewer>
</template>
<script>

export default {
  name: 'home',
  props: {
    url: String,
    title: String,
    canGoBack: Boolean,
  },
  methods: {
    onClose() {
      if (this.canGoBack) {
        this.$router.go(-1);
      } else {
        const components = this.$router.currentRoute.path.split('/');
        const newPath = components.slice(0, 2).join('/');
        this.$router.push({ path: newPath });
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.canGoBack = !!from.name;
    });
  }
};
</script>